import { MODULE_ID } from './constants';
export const CHECK_INFORMATION = `${MODULE_ID}/CHECK_INFORMATION`;
export const CHECK_INFORMATION_SUCCESS = `${MODULE_ID}/CHECK_INFORMATION_SUCCESS`;
export const CHECK_INFORMATION_ERROR = `${MODULE_ID}/CHECK_INFORMATION_ERROR`;
export const SET_BASIC_INFORMATION_UPDATE = `${MODULE_ID}/SET_BASIC_INFORMATION_UPDATE`;
export const FETCH_CONSENTS_TEMPLATE = `${MODULE_ID}/FETCH_CONSENTS_TEMPLATE`;
export const FETCH_CONSENTS_TEMPLATE_SUCCESS = `${MODULE_ID}/FETCH_CONSENTS_TEMPLATE_SUCCESS`;
export const FETCH_CONSENTS_TEMPLATE_ERROR = `${MODULE_ID}/FETCH_CONSENTS_TEMPLATE_ERROR`;
export const SEND_INFORMATION = `${MODULE_ID}/SEND_INFORMATION`;
export const SEND_INFORMATION_SUCCESS = `${MODULE_ID}/SEND_INFORMATION_SUCCESS`;
export const SEND_INFORMATION_ERROR = `${MODULE_ID}/SEND_INFORMATION_ERROR`;
export const FETCH_PROFILE_AVATAR = `${MODULE_ID}/FETCH_PROFILE_AVATAR`;
export const FETCH_PROFILE_AVATAR_SUCCESS = `${MODULE_ID}/FETCH_PROFILE_AVATAR_SUCCESS`;
export const FETCH_PROFILE_AVATAR_ERROR = `${MODULE_ID}/FETCH_PROFILE_AVATAR_ERROR`;
